'use strict';
(function () {
  angular.module('pentaApp').factory('inqueryLog.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/inqueryLog');
  }
})();
